module.exports = __webpack_public_path__ + "img/pen-write.a4813fad.svg";